var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivationSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.375 125C19.875 125 17.6875 124.062 15.8125 122.187C13.9375 120.312 13 118.125 13 115.625V34.375C13 31.875 13.9375 29.6875 15.8125 27.8125C17.6875 25.9375 19.875 25 22.375 25H128.625C131.125 25 133.312 25.9375 135.187 27.8125C137.062 29.6875 138 31.875 138 34.375V115.625C138 118.125 137.062 120.312 135.187 122.187C133.312 124.062 131.125 125 128.625 125H22.375ZM75.5 77.8125L128.625 42.9688V34.375L75.5 68.4375L22.375 34.375V42.9688L75.5 77.8125Z",
    fill: "current"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 34,
    r: 25,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.05 43.1L132.2 28.95L129.9 26.7L118.05 38.55L112.05 32.55L109.8 34.8L118.05 43.1ZM121 54C118.267 54 115.683 53.475 113.25 52.425C110.817 51.375 108.692 49.9417 106.875 48.125C105.058 46.3083 103.625 44.1833 102.575 41.75C101.525 39.3167 101 36.7333 101 34C101 31.2333 101.525 28.6333 102.575 26.2C103.625 23.7667 105.058 21.65 106.875 19.85C108.692 18.05 110.817 16.625 113.25 15.575C115.683 14.525 118.267 14 121 14C123.767 14 126.367 14.525 128.8 15.575C131.233 16.625 133.35 18.05 135.15 19.85C136.95 21.65 138.375 23.7667 139.425 26.2C140.475 28.6333 141 31.2333 141 34C141 36.7333 140.475 39.3167 139.425 41.75C138.375 44.1833 136.95 46.3083 135.15 48.125C133.35 49.9417 131.233 51.375 128.8 52.425C126.367 53.475 123.767 54 121 54Z",
    fill: "#58E05D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivationSent);
export default __webpack_public_path__ + "static/media/activationSent.5bd0ff0bdf798fbbacec962a3671308f.svg";
export { ForwardRef as ReactComponent };